import { render, staticRenderFns } from "./document-details.vue?vue&type=template&id=8bb25d20&scoped=true&"
import script from "./document-details.vue?vue&type=script&lang=js&"
export * from "./document-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb25d20",
  null
  
)

export default component.exports